import axios from "axios";
import { format } from "date-fns";
import React, { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import CommonTransactionPaginationTable from "../../../common/components/CommonTable/CommonDynamicTablePaginationNew";
import DatePickerField from "../../../common/components/FormFields/DatePickerFieldNew";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import {
  getTemplateAutoComplete,
  getTemplateWiseReports,
} from "../../services/feedbackservices/FeedbackServices";

function TemplateWiseReport() {
  const defaultValues = {
    templateName: null,
    fromDate: new Date(),
    toDate: new Date(),
  };

  const { control, watch, reset } = useForm({
    mode: "onChange",
    defaultValues,
  });
  // local variables
  let tempalateNameValue = watch("templateName");
  let fromDateValue = watch("fromDate");
  let toDateValue = watch("toDate");
  // state variables
  const [templateListData, setTemplateListData] = useState([]);
  const [templateOptions, setTemplateOptions] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState();
  const [listingObject, setListingObject] = useState({
    searchString: tempalateNameValue?.label,
    id: tempalateNameValue?.id,
    fromDate:
      fromDateValue !== null
        ? format(new Date(fromDateValue), "yyyy-MM-dd'T'HH:mm:ss.000'Z'")
        : null,
    page: page ? page : 0,
    size: rowsPerPage ? rowsPerPage : 10,
    toDate:
      toDateValue !== null
        ? format(new Date(toDateValue), "yyyy-MM-dd'T'HH:mm:ss.000'Z'")
        : null,
  });

  const populateTable = (forPagination) => {
    let obj = {
      searchString: tempalateNameValue?.label,
      id: tempalateNameValue?.id,
      departmentId: null,
      templateFor: "",
      fromDate:
        fromDateValue !== null
          ? format(new Date(fromDateValue), "yyyy-MM-dd'T'HH:mm:ss.000'Z'")
          : null,
      page: page ? page : 0,
      size: rowsPerPage ? rowsPerPage : 10,
      toDate:
        toDateValue !== null
          ? format(new Date(toDateValue), "yyyy-MM-dd'T'HH:mm:ss.000'Z'")
          : null,
    };
    getTemplateWiseReports(obj)
      .then((response) => response.data)
      .then((res) => {
        if (forPagination) {
          if (res.result && Array.isArray(res.result)) {
            setTemplateListData((prevData) => [...prevData, ...res.result]);
          }
        } else {
          setTemplateListData(res.result || []);
          setPage(0);
        }
        setCount(res.count);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  console.log("template name", tempalateNameValue);
  const handleInputTemplateName = (value) => {
    if (value !== "") {
      getTemplateAutoComplete(value)
        .then((response) => {
          console.log("templateName", response.data.result);
          setTemplateOptions(response.data.result);
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  };

  useMemo(() => {
    populateTable();
  }, [
    listingObject.searchString,
    listingObject.fromDate,
    listingObject.toDate,
  ]);
  return (
    <>
      <div>
        <h1 className=" my-2 font-semibold whitespace-nowrap text-base tracking-wide">
          Template Wise Reports
        </h1>
        <div className="grid grid-cols-2 gap-2 xl:flex xl:space-x-3  w-full">
          <div className="w-full xl:w-4/12">
            <SearchDropdown
              name="templateName"
              control={control}
              placeholder="Template Name"
              handleInputChange={handleInputTemplateName}
              searchIcon={true}
              dataArray={templateOptions}
              isClearable={true}
            />
          </div>
          <div>
            <DatePickerField
              name="fromDate"
              control={control}
              label="From Date"
              inputFormat="dd-MM-yyyy"
            />
          </div>
          <div>
            <DatePickerField
              name="toDate"
              control={control}
              label="To Date"
              inputFormat="dd-MM-yyyy"
            />
          </div>
          <div className="flex space-x-3">
            <CommonButton
              type="button"
              label="Reset"
              className="border border-customRed text-customRed"
              onClick={() => {
                reset(defaultValues);
              }}
            />
     
            <CommonButton
              searchIcon={true}
              type="button"
              className="bg-customBlue text-white h-9"
              onClick={() => {
                setListingObject((listingObject) => ({
                  ...listingObject,
                  searchString: tempalateNameValue,
                  fromDate:
                    fromDateValue !== null
                      ? format(new Date(fromDateValue), "yyyy-MM-dd")
                      : null,
                  page: page ? page : 0,
                  size: rowsPerPage ? rowsPerPage : 10,
                  toDate:
                    toDateValue !== null
                      ? format(new Date(toDateValue), "yyyy-MM-dd")
                      : null,
                }));
              }}
            />
          </div>
        </div>
      </div>
      <div className="w-full">
        {templateListData?.length > 0 ? (
          <div className="mt-2">
            <CommonTransactionPaginationTable
              populateTable={populateTable}
              dataResult={templateListData}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              count={count}
              setRowsPerPage={setRowsPerPage}
              highlightRow={false}
              removeHeaders={["Id", "Sr No"]}
              tableClass={"h-[370px]"}
            />
          </div>
        ) : (
          <div className="flex justify-center">
            <h3 className="flex justify-center my-28 font-bold text-gray-600">
              No Records Found...
            </h3>
          </div>
        )}
      </div>
    </>
  );
}

export default TemplateWiseReport;

